import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { AdapterTypeEnum } from '@zaoblako/shared/modules/traffic/enums/adapter.type.enum';
import { AdapterTypeEnumI18n } from '@zaoblako/shared/modules/traffic/i18n/adapter-type-enum.i18n';

@Pipe({
  name: 'adapterTypeName',
  standalone: true
})
export class AdapterTypeNamePipe implements PipeTransform {
  public transform(type: AdapterTypeEnum): string {
    return AdapterTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
